import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsAdmin() {
  const { user } = useAuth();
  const { data: isAdmin = false, isLoading } = useQuery({
    queryKey: ["is-admin", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("has_admin_role", {
        _user_id: user!.id,
      });
      if (error) return false;
      return !!data;
    },
    staleTime: 5 * 60 * 1000,
  });
  return { isAdmin, isLoading };
}
